/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import { mapRemoteResource, useMerchantConfig } from "../api/hooks.js";
import { PaymentServicesScreen } from "../screens/PaymentServicesScreen.js";

/**
 * The payment services this server accepts coins from.
 *
 * The screen used to be mounted with no props at all, so every merchant was
 * shown the same two invented services belonging to nobody. The real list is
 * the `exchanges` array of the merchant's own `/config`.
 */
export function PaymentServicesRoute(): VNode {
  const { exchanges, isLoading, resource } = useMerchantConfig();
  const exchangesResource = mapRemoteResource(
    resource,
    (config) => config.exchanges,
  );
  return (
    <PaymentServicesScreen
      exchanges={exchanges || []}
      isLoading={isLoading}
      exchangesResource={exchangesResource}
    />
  );
}
